const RES = window.RES,
    $ = jQuery

import ScriptsLoader from '../loaders/AsyncScriptsLoader'

export default class ServicesOnMap {

    constructor($root) {
        this.root = $root

        this.countriesMapping = getData()

        this.scriptsLoader = new ScriptsLoader([
            'assets/world-map/d3.min.js',
            'assets/world-map/topojson.min.js',
            'assets/world-map/datamaps.world.min.js',
            'assets/world-map/d3-array.v1.min.js',
            'assets/world-map/d3-geo.v1.min.js',
            'assets/world-map/d3-geo-projection.v2.min.js',
        ].map(path => RES.global('templateURI') + '/' + path))

        this._mapInitialized = false
        this._blocked = false

        this.map = null

        this.unavailableRedirectUrl = this.root.data('unavailable-redirect-url')

        this.mapContainer = this.root.find('#som-world-map')
        this.items = this.root.find('.som-item').toArray().map(item => $(item))
        this.sections = this.root.find('.som-worldPart').toArray().map(p => $(p))
        this.worldPartsButtons = this.root.find('.som-worldParts-button').toArray().map(b => $(b))

        this.scriptsLoader.onLoad(() => {
            this.initMap()
            const activeWorldPart = this.worldPartsButtons.find(b => b.hasClass('active'))
            if (activeWorldPart && activeWorldPart.length) {
                activeWorldPart.trigger('click')
            }
        })
        this.scriptsLoader.load()
    }

    initMap() {

        let props = {
            element: this.mapContainer.get(0),
            responsive: true,
            // projection: 'mercator',
            setProjection: (element, options) => {

                // adjust map scale based on window width
                let coef = ((window.innerWidth / 1920) + 1.25) / 3
                let scale = window.innerWidth / (10 * coef)

                const times = d3.geoTimes()
                    .center([18, 0])
                    .scale(scale)
                    .translate([element.offsetWidth / 2, element.offsetHeight / 1.7])

                return {
                    times,
                    path: d3.geo.path().projection(times),
                }
            },
            fills: {
                defaultFill: '#5a5a5a',
                FEATURED: '#ffd300',
            },
            data: {},
            geographyConfig: {
                borderColor: '#9e9e9e',
                borderWidth: 0.5,
                popupOnHover: false,
                highlightOnHover: false,
            },
            // done: datamap => {
            //   datamap.svg.selectAll('.datamaps-subunit').on('click', (...geo) => {
            //     console.log(...geo)
            //   })
            // }
        }

        this.map = new Datamap(props)
        $(window).on('resize orientationchange', () => {
            this.mapContainer.children('svg')
                .attr('width', this.mapContainer.width())
                .attr('height', this.mapContainer.height())
                .attr('data-width', this.mapContainer.width())
                .attr('data-height', this.mapContainer.height())
            this.map.resize()
        })

        this._mapInitialized = true
        this.countries = this.mapContainer.find('.datamaps-subunit').toArray().map(c => $(c))
        this.countries.forEach(country => {
            // const code = [].slice.apply(country[0].classList).find(c => c.match(/[A-Z]{3}/)),
            const code = country[0].className.baseVal.split(' ').find(c => c.match(/[A-Z]{3}/)),
                worldPart = this.countriesMapping.getCountryWorldPart(code),
                item = this.items.find(i => i.data('country') && i.data('country').a3 === code)

            if (item) {
                country.addClass('item')
            }

            country
                .on('click', () => {
                    country.hasClass('item') || !this.unavailableRedirectUrl
                    ? this.filterWorldPart(worldPart)
                    : (Object.assign(document.createElement('a'), {
                        href: this.unavailableRedirectUrl,
                        target: '_blank',
                    }).click())
                })
                .on('mouseenter', () => {
                    let worldPartNeighbours = this.countriesMapping.getWorldPartCountries(worldPart)
                    if (this.unavailableRedirectUrl) {
                        const neighbours = this.countries
                            .filter(c => item ? c.hasClass('item') : !c.hasClass('item'))
                        worldPartNeighbours = worldPartNeighbours.filter(code => neighbours.find(c => c.hasClass(code)))
                    }

                    this.highlightCountries('hover', worldPartNeighbours)
                })
                .on('mouseleave', () => this.highlightCountries('hover'))
        })
        this.mapContainer.on('click', event => {
            if (!event.target.className.baseVal.includes('datamaps-subunit')) {
                this.highlightCountries('active')
                this.sections.forEach(item => item.removeClass('hidden'))
                this.worldPartsButtons.forEach(button => {
                    if (button.data('world-part')) {
                        button.removeClass('active')
                    } else {
                        button.addClass('active')
                    }
                })
            }
        })
        this.worldPartsButtons.forEach(button => {
            button.on('click', () => {
                this.filterWorldPart(button.data('world-part'))
            })
        })
    }

    filterWorldPart(worldPart = null) {

        if (this.worldPartsButtons.length) {
            $('html, body').animate({
                scrollTop: this.worldPartsButtons[0].offset().top,
            }, 500)
        }
        // console.log(worldPart);
        if (worldPart) {
            this.sections.forEach(item => {
                if (item.data('world-part') === worldPart) {
                    item.removeClass('hidden')
                } else {
                    item.addClass('hidden')
                }
            })
            this.highlightCountries('active', this.countriesMapping.getWorldPartCountries(worldPart))
            this.worldPartsButtons.forEach(button => {
                if (button.data('world-part') === worldPart) {
                    button.addClass('active')
                } else {
                    button.removeClass('active')
                }
            })
        } else {
            this.highlightCountries('active')
            this.sections.forEach(item => item.removeClass('hidden'))
            this.worldPartsButtons.forEach(button => {
                if (button.data('world-part')) {
                    button.removeClass('active')
                } else {
                    button.addClass('active')
                }
            })
        }
    }

    highlightCountries(className, countryCodes = []) {
        if (countryCodes.length) {
            this.countries.forEach(country => {
                if (country[0].className.baseVal.split(' ').some(code => countryCodes.includes(code))) {
                    country.addClass(className)
                } else {
                    country.removeClass(className)
                }
            })
        } else {
            this.countries.forEach(country => country.removeClass(className))
        }
    }

    block() {
        this._blocked = true
    }

    release() {
        this._blocked = false
    }
}


function getData() {
    const a3ToWorldPart = window.som_getA3ToWorldPartMapping ? window.som_getA3ToWorldPartMapping() : []
    return {

        getCountryWorldPart(countryA3) {
            return a3ToWorldPart[countryA3]
        },

        getWorldPartCountries(worldPart) {
            return Object.keys(a3ToWorldPart).filter(a3 => a3ToWorldPart[a3] === worldPart)
        },
    }
}
